import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Box, Typography, useTheme } from '@mui/material';

import { getAdvisors } from '../../../redux/providers/providers.slice';
import { setPageTitle } from '../../../redux/title/title.slice';

import PrimaryButton from '../../../components/ui/buttons/primaryButton';
import SecondaryButton from '../../../components/ui/buttons/secondaryButton';
import Loader from '../../../components/ui/loader';
import { FTable, FTableCell } from '../../../components/ui/table';
import RevealAndCopyValue from '../../../components/portalComponents/revealTypography';
import RevealTypography from '../../../components/portalComponents/revealTypography';

export default function Advisors() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();

  const { advisors, loadingAllAdvisors } = useSelector((state) => state.providers);

  // Fetch ALL advisors (partners)
  useEffect(() => {
    dispatch(getAdvisors());
  }, [dispatch]);

  // Set page title
  useEffect(() => {
    dispatch(setPageTitle('Advisors'));
  }, [dispatch]);

  if (loadingAllAdvisors) {
    return <Loader loading={true} message="Loading advisors..." />;
  }

  const columns = [
    { label: 'Name', width: '15%' },
    { label: 'Surname', width: '15%' },
    { label: 'Email', width: '45%' },
    { label: 'Actions', width: '25%' }
  ];

  return (
    <FTable
      title="Advisors"
      columns={columns}
      rows={advisors}
      emptyMessage="No advisors found"
      renderRow={(advisor) => (
        <>
          <FTableCell>{advisor.name1 || '—'}</FTableCell>

          <FTableCell>{advisor.name2 || '—'}</FTableCell>

          <FTableCell>
            <RevealTypography
              value={advisor.email}
              mask="email"
              TypographyProps={{ variant: 'body2' }}
              tooltip="View Email"
            />
          </FTableCell>

          <FTableCell
            sx={{
              display: 'flex',
              justifyContent: 'space-evenly'
            }}>
            <PrimaryButton onClick={() => navigate(`/my-practice/advisors/${advisor.id}`)}>
              Codes
            </PrimaryButton>
            <SecondaryButton>Invite</SecondaryButton>
          </FTableCell>
        </>
      )}
    />
  );
}
